export default __webpack_public_path__ + "static/media/futurecraft.15ab206d.mp4";